module.exports = __webpack_public_path__ + "img/ball_1_orange.e1808143.png";